import type { MarketDataMap } from "../../hooks";

export const getPriceInUSD = (marketDataMap: MarketDataMap, mint: string): number => {
  const token = marketDataMap.get(mint);
  if (token && token.price > 0) {
    return token.price;
  }
  return 0;
};

// This function is meant to be used to fix when getPriceInUSD is used to get pending rewards in LPs,
// since it returns big negative balances that break the UI
// I.E: https://step-finance.atlassian.net/browse/SF-1054
export const priceInUSDWrapper = (price: number): number => {
  return price > 0 ? price : 0;
};
